module.exports = __webpack_public_path__ + "img/ostrinia-furnacalis.1304b4d2.jpg";